import { z } from "zod";

import dayjs from "@/lib/helpers/dayjs";

export const approveCosignSchema = z.object({
  acknowledgment_details: z.string().max(1000, "Cannot exceed 1000 characters").optional(),
  isConfirmed: z.boolean().refine((v) => v, "You must confirm before co-signing"),
});

export type ApproveCosignFormValues = z.infer<typeof approveCosignSchema>;

export const rejectNoteSchema = z.object({
  rejectionReason: z
    .string()
    .min(1, "Rejection reason is required")
    .max(1500, "Rejection reason cannot exceed 1500 characters"),
});

export type RejectNoteFormValues = z.infer<typeof rejectNoteSchema>;

export const noteHistorySchema = z.array(
  z.object({
    acknowledgment_details: z.string().nullish(),
    assigned_supervisor_credentials: z.string().nullish(),
    assigned_supervisor_id: z.guid().nullish(),
    assigned_supervisor_name: z.string().nullish(),
    cosignature_status: z.enum(["pending", "rejected", "resubmitted", "signed"]),
    document_id: z.guid(),
    document_type: z.enum(["note", "note_addendum"]),
    document_version: z.number().int().min(1),
    provider_credentials: z.string().nullish(),
    provider_id: z.guid().nullish(),
    provider_name: z.string().nullish(),
    rejection_reason: z.string().nullish(),
    reviewing_supervisor_credentials: z.string().nullish(),
    reviewing_supervisor_id: z.guid().nullish(),
    reviewing_supervisor_name: z.string().nullish(),
    signature: z.string().nullish(),
    timestamp: z.string().refine((value) => dayjs(value).isValid(), "Invalid history timestamp"),
  }),
);
